import { render, staticRenderFns } from "./RemotePaginatedList.vue?vue&type=template&id=78a56ac8"
import script from "./RemotePaginatedList.vue?vue&type=script&lang=js"
export * from "./RemotePaginatedList.vue?vue&type=script&lang=js"
import style0 from "./RemotePaginatedList.vue?vue&type=style&index=0&id=78a56ac8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports